import { render, staticRenderFns } from "./VaTabs.demo.vue?vue&type=template&id=2eebf23e&"
import script from "./VaTabs.demo.vue?vue&type=script&lang=js&"
export * from "./VaTabs.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports